import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import type SessionService from 'district-ui-client/services/session'
import { SubscriptionType } from 'district-ui-client/domain/subscription-type'

/**
 * Visit top level /support to be redirected to one of the subscription-type tabs.
 */
export default class SupportRoute extends Route {
  @service router!: RouterService
  @service session!: SessionService

  beforeModel(): void {
    const subscriptionType = this.session.currentDisco.subscriptionTypes[0] ?? SubscriptionType.Reading
    void this.router.transitionTo('subscription-type.support', subscriptionType)
  }
}
